import { ClockIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { Link } from "react-router-dom";
import SuperAdmin from "../users/permissions/SuperAdmin";

interface IChangeHistoryLink {
  // The entity's CLR name on the backend, e.g. `Trip` or `Line`.
  entityName: string;
  entityId: string | number | undefined;
  className?: string;
}

// Link from an entity's edit screen to its change history. SuperAdmins only, like the page itself.
const ChangeHistoryLink: FC<IChangeHistoryLink> = ({ entityName, entityId, className = "" }) => {
  if (!entityId) return null;
  return (
    <SuperAdmin>
      <Link
        className={`flex items-center text-sm font-semibold text-primary ${className}`}
        to={`/change-history?entityName=${encodeURIComponent(entityName)}&entityId=${entityId}`}
        state={["Historiku i ndryshimeve"]}
      >
        <ClockIcon className="w-4 h-4 mr-2" />
        <span>Historiku i ndryshimeve</span>
      </Link>
    </SuperAdmin>
  );
};

export default ChangeHistoryLink;
